import { render, staticRenderFns } from "./EmployeeList.vue?vue&type=template&id=6b778a99"
import script from "./EmployeeList.vue?vue&type=script&lang=js"
export * from "./EmployeeList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports